<template>
  <div class="ui bottom tab segment" data-tab="additional_condition">
    <form class="ui form" :class="{'loading': form.waiting}">
      <div class="field">
        <button type="button" class="ui positive button" @click="save()">保存する</button>
      </div>
      <div class="ui stackable three column grid">
        <div v-for="each in additionalConditions" :key="each.value" class="column">
          <div class="field">
            <div class="ui checkbox">
              <input v-model="each.checked" type="checkbox" value="true">
              <label>{{ each.label }}</label>
            </div>
           (
            <div class="ui checkbox" style="margin-right: 0;">
              <input v-model="each.is_conditional" type="checkbox" value="true" :disabled="!each.checked">
              <label>条件付き</label>
            </div>
           )
          </div>
          <div class="field">
            <textarea :disabled="!each.checked" rows="2" v-model="each.note" :placeholder="each.placeholder"></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm(),
            model: {},
            additionalConditions: [],
        };
    },
    methods: {
        initialize: function(model) {
            this.model = model;
            this.update(model.additional_conditions);
        },
        update: function(additionalConditions) {
            this.clearArray(this.additionalConditions);
            _.forEach(this.consts.ADDITIONAL_CONDITION, function(each) {
                var additionalConditionModel = {
                    label: each.label,
                    additional_condition_id: each.value,
                    placeholder: each.placeholder || '備考',
                    is_conditional: false,
                };
                var additionalCondition = _.find(additionalConditions, { additional_condition_id: each.value });
                if (additionalCondition) {
                    additionalConditionModel.checked = true;
                    additionalConditionModel.note = additionalCondition.note;
                    additionalConditionModel.is_conditional = additionalCondition.is_conditional;
                }
                this.additionalConditions.push(additionalConditionModel);
            }.bind(this));
            this.$nextTick(function() {
                $('.ui.checkbox', this.$el).checkbox();
            });
        },
        save: function() {
            this.form.model = {
                additional_conditions: _.filter(this.additionalConditions, {'checked': true})
            };
            this.form.put(this.model.update_additional_condition_api_url, function(response) {
                this.update(response.data);
                alert('更新しました');
            }.bind(this));
        }
    }
};
</script>

